import { QuestionCircleOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import classNames from 'classnames'
import { useAtom } from 'jotai'
import { useMemo, useState } from 'react'
import InputArea from '~/components/pages/ai/InputArea'
import { MyForm } from '~/components/ui/MyForm'
import styles from '../AiForm.module.css'
import { Dice } from './Dice'
import Router from 'next/router'
import { promptAtom, selectModelAtom, tagCategoryIdAtom } from './atom'
import { useType } from '../useType'

export const PromptComp: React.FC = () => {
  const [prompt, setPrompt] = useAtom(promptAtom)
  const [selectModel] = useAtom(selectModelAtom)
  const { isMJ, isST, isAD, isSD, isMask, isTransparent, isGeneral } = useType()
  const [tagCategoryId] = useAtom(tagCategoryIdAtom)

  /** 画面描述placeholder */
  const promptPlaceholder = useMemo(() => {
    if (isMask) {
      return '输入画面描述生成的内容会替代涂抹区域的画面，当未输入或只输入“修复”两个字会将涂抹区域进行自动修复'
    }
    if (isTransparent) {
      return '画面描述以短句、短语为佳，支持中英文输入'
    }
    return '画面描述以短句、短语为佳，建议40个字符以上；风格选择和高级参数对图像生成有艺术修饰作用；支持中英文输入'
  }, [isMask, isTransparent])

  return (
    <>
      <div className="flex items-center justify-between mb-2">
        <div className="h-[30px] leading-[30px] text-neutral-500">
          * 画面描述{' '}
          {isMask && (
            <Tooltip
              placement="topLeft"
              arrowPointAtCenter
              title="画面尺寸参数指生成图片的最终大小，其它参数只对涂抹的区域图像有艺术修饰作用"
            >
              <QuestionCircleOutlined />
            </Tooltip>
          )}
        </div>
        <div className="flex">
          {(isSD || isAD || isST) && isGeneral && (
            <div
              className="relative bg-neutral-200 text-xs font-semibold py-1 px-3 rounded-full text-white cursor-pointer"
              onClick={() => {
                if (tagCategoryId) {
                  Router.push(`/tag-generator/tags?id=${tagCategoryId}`)
                } else if (isSD) {
                  Router.push(`/tag-generator/tags`)
                } else {
                  Router.push(`/tag-generator?model=${selectModel}`)
                }
              }}
            >
              <div>标签生成器</div>
            </div>
          )}
          {isMJ && (
            <div
              className="relative bg-neutral-200 text-xs font-semibold py-1 px-3 rounded-full text-white cursor-pointer"
              onClick={() => {
                Router.push(`/lab/img2tag`)
              }}
            >
              <div>咒语解析器</div>
              <img
                className="h-[14px] absolute -top-2 right-0"
                src="/images/ai/new.png"
                alt=""
              ></img>
            </div>
          )}
        </div>
      </div>
      <MyForm.Item className={classNames(styles.borderLessFormItem, '!mb-8')}>
        <InputArea
          placeholder={promptPlaceholder}
          value={prompt}
          onChange={setPrompt}
        />
        {isGeneral && <Dice />}
      </MyForm.Item>
    </>
  )
}
